import { FormField } from "../../../../models/Form";

export const getChildrenTypes = (child: FormField) => {
	const childrenTypes: string[] | undefined = child.children
		?.filter((it) => it !== undefined)
		.flatMap((it) => it)
		.map((it) => it.type);
	return childrenTypes;
};
